import React, { lazy } from 'react';
import { Router, Route, Switch, BrowserRouter} from 'react-router-dom';
import App from '../App';

const RouterConfig = () => (
    <BrowserRouter>
        <Route path={"/*"} component={App} />
    </BrowserRouter>
);
export default RouterConfig;


